import { render } from "./NewPaymentCheckbox.vue?vue&type=template&id=6bb01d88"
import script from "./NewPaymentCheckbox.vue?vue&type=script&lang=js"
export * from "./NewPaymentCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__